import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Typography } from '@mui/material';

import TestCasesByUser from './metrics/TestCasesByUser';
import TestCasesAssignedToUser from './metrics/TestCasesAssignedToUser';
import TestCasesNotAutomated from './metrics/TestCasesNotAutomated';
import DefectsLoggedInProject from './metrics/DefectsLoggedInProject';
import TestCasePyramidMetrics from './metrics/TestCasePyramidMetrics';
import TestCasesPerAuthor from './metrics/TestCasesPerAuthor';
import TestCaseCoverageByModule from './metrics/TestCaseCoverageByModule';
// import TestCycleCoverageByModule from './metrics/TestCycleCoverageByModule';
import ExecutionsPerUser from './metrics/ExecutionsPerUser';
import TestCasesPassFailInTestCycle from './metrics/TestCasesPassFailInTestCycle';
// import TestCycleByExecutionType from './metrics/TestCycleByExecutionType';
import NumberOfIterationInTestCycle from './metrics/NumberOfIterationInTestCycle';
import NumberOfDaysForTestCycles from './metrics/NumberOfDaysForTestCycles';
import AutomationProgressByWeek from './metrics/AutomationProgressBySprint';
import IssuesByTestCycle from './metrics/IssuesByTestCycle';
import DefectMetrics from './metrics/defects/DefectMetrics';
import DefectDetectionRate from './metrics/defects/DefectDetectionRate';
import IssuesLoggedPerStatusForCustomType from './metrics/defects/IssuesLoggedPerStatusForCustomType';
import TestRequirementCoverage from './metrics/test-requirements/TestRequirementCoverage';
import SprintCompletionMetrics from './metrics/test-requirements/SprintCompletionMetrics';
import TestAutomationMetrics from '../../../Home/reports/TestAutomationMetrics';
import HomeDefectMetrics from '../../../Home/reports/HomeDefectMetrics';

const DashboardSections = ({
  currentView,
  projectId,
  isAdmin,
  dateFilters,
  isJiraIntegrated,
  selectedJiraProject,
  sectionRefs,
}) => {
  const sections = {
    'common-widgets': (
      <>
        <Row className="pt-3">
          <Col md="3" sm="6" xs="6" className="widget">
            <TestCasesByUser projectId={projectId} isAdmin={isAdmin} />
          </Col>
          {!isAdmin && (
            <Col md="3" sm="6" xs="6" className="widget">
              <TestCasesAssignedToUser projectId={projectId} />
            </Col>
          )}
          <Col md="3" sm="6" xs="6" className="widget">
            <TestCasesNotAutomated projectId={projectId} isAdmin={isAdmin} />
          </Col>
          <DefectsLoggedInProject
            projectId={projectId}
            isAdmin={isAdmin}
            isJiraIntegrated={isJiraIntegrated}
            selectedJiraProject={selectedJiraProject}
          />
        </Row>
        <Row>
          <Col>
            <TestAutomationMetrics
              projectIds={[projectId]}
              showAccordion={false}
              page={'dashboard'}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <HomeDefectMetrics
              projectIds={[projectId]}
              showAccordion={false}
              page={'dashboard'}
            />
          </Col>
        </Row>
      </>
    ),
    'test-design': (
      <>
        <Typography variant="h5" className="dashboard-heading">
          Test Design
        </Typography>
        <Row className="mt-4">
          <TestCasePyramidMetrics projectId={projectId} />
        </Row>
        <Row className="mt-4">
          <Col>
            <TestCaseCoverageByModule projectId={projectId} />
          </Col>
        </Row>
        {isAdmin && (
          <Row className="mt-4">
            <Col col={6}>
              <TestCasesPerAuthor projectId={projectId} dateFilters={dateFilters} />
            </Col>
          </Row>
        )}
        {/* <Row className="mt-4">
          <Col>
            <TestCycleCoverageByModule projectId={projectId} dateFilters={dateFilters} />
          </Col>
        </Row> */}
      </>
    ),
    'test-execution': (
      <>
        <Typography variant="h5" className="dashboard-heading">
          Test Execution
        </Typography>
        {isAdmin && (
          <Row>
            <ExecutionsPerUser projectId={projectId} dateFilters={dateFilters} />
          </Row>
        )}
        <Row className="mt-3">
          <Col>
            <TestCasesPassFailInTestCycle projectId={projectId} dateFilters={dateFilters} />
          </Col>
          {/* <Col>
            <TestCycleByExecutionType projectId={projectId} dateFilters={dateFilters} />
          </Col> */}
        </Row>

        <Row className="mt-3">
          <Col>
            <NumberOfIterationInTestCycle projectId={projectId} dateFilters={dateFilters} />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <NumberOfDaysForTestCycles projectId={projectId} />
          </Col>
        </Row>
      </>
    ),
    'test-automation': (
      <>
        <Typography variant="h5" className="dashboard-heading">
          Test Automation
        </Typography>
        <Row>
          <Col>
            <AutomationProgressByWeek projectId={projectId} />
          </Col>
        </Row>
      </>
    ),
    defects: (
      <>
        <Typography variant="h5" className="dashboard-heading">
          Defects
        </Typography>
        <Row>
          <Col>
            <IssuesByTestCycle
              setShowExport={() => { }}
              projectId={projectId}
              dateFilters={dateFilters}
              isJiraIntegrated={isJiraIntegrated}
              selectedJiraProject={selectedJiraProject}
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <DefectMetrics
            projectId={projectId}
            isAdmin={isAdmin}
            setShowExport={() => { }}
            dateFilters={dateFilters}
            isJiraIntegrated={isJiraIntegrated}
            selectedJiraProject={selectedJiraProject}
          />
        </Row>
        <Row className="my-3">
          <DefectDetectionRate
            projectId={projectId}
            setShowExport={() => { }}
            dateFilters={dateFilters}
            isJiraIntegrated={isJiraIntegrated}
            selectedJiraProject={selectedJiraProject}
          />
        </Row>
        <Row className="my-3">
          <IssuesLoggedPerStatusForCustomType
            projectId={projectId}
            setShowExport={() => { }}
            dateFilters={dateFilters}
            isJiraIntegrated={isJiraIntegrated}
            selectedJiraProject={selectedJiraProject}
          />
        </Row>
      </>
    ),
    'requirement-coverage': (
      <>
        <Typography variant="h5" className="dashboard-heading">
          Requirement Coverage{' '}
          <Typography variant="body2">
            {`${isJiraIntegrated ? `(${selectedJiraProject?.linked_project_name})` : ''}`}
          </Typography>
        </Typography>
        <Row className="mt-4">
          <TestRequirementCoverage
            projectId={projectId}
            selectedJiraProject={selectedJiraProject}
            isJiraIntegrated={isJiraIntegrated}
          />
        </Row>
        <Row className="mt-4">
          <SprintCompletionMetrics
            projectId={projectId}
            isAdmin={isAdmin}
            setShowExport={() => { }}
            dateFilters={dateFilters}
            isJiraIntegrated={isJiraIntegrated}
            selectedJiraProject={selectedJiraProject}
          />
        </Row>
      </>
    ),
  };

  if (!currentView) {
    return (
      <div
        ref={(el) => (sectionRefs.current['common-widgets'] = el)}
        className="section-wrapper">
        {sections['common-widgets']}
      </div>
    );
  }

  return (
    <div
      ref={(el) => (sectionRefs.current[currentView || 'common-widgets'] = el)}
      className="section-wrapper"
    >
      {sections[currentView] || sections['common-widgets']}
    </div>
  );
};

export default DashboardSections;
